import { IOrderService } from '../../../../app/entities/OrderService'
import { PERMISSIONS } from '../../global/constants/permissions'

export function getRescheduleQueueAssignToUsersList() {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/users/permission?permissionName=${PERMISSIONS.QUEUES.ENTRIES.RESCHEDULE_ENTRIES_ASSIGNEE.NAME}`,
  }
}

export function assignUserToOrder(orderId: string, assignedTo: string | null) {
  const body = {
    assignedTo,
  }
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderId}/assignedTo`,
    body,
  }
}

export function updateOrderService(orderService: IOrderService) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/order_service`,
    body: orderService,
  }
}

export function rejectDeliveryCandidate(deliveryCandidateObjectId: string) {
  return {
    method: 'PATCH',
    url: `${process.env.REACT_APP_ORIGIN}/delivery-candidates/${deliveryCandidateObjectId}/reject`,
  }
}

export function forceDeliveryCandidateAppointment(
  deliveryCandidateObjectId: string,
  routeObjectId: string,
  routeInstructionTime: string,
) {
  return {
    method: 'PATCH',
    url: `${process.env.REACT_APP_ORIGIN}/delivery-candidates/${deliveryCandidateObjectId}/force-appointment`,
    body: {
      routeObjectId,
      routeInstructionTime,
    },
  }
}

export function getRoutes(locationObjectId?: string) {
  let url = `${process.env.REACT_APP_ORIGIN}/routes/future`

  if (locationObjectId) {
    url += `?locationObjectId=${locationObjectId}`
  }

  return {
    method: 'GET',
    url,
  }
}
